<template>
	<ul
		:class="['list', disabled && 'is-disabled']"
		:disabled="disabled"
		data-testid="list"
	>
		<li class="list__item" v-for="(item, index) in listItems" :key="index">
			<slot v-bind:item="item"></slot>
		</li>
	</ul>
</template>

<script>
export default {
	name: 'List',
	/**
	 * Array of object in format:
	 * {
	 * 	label: 'display label'
	 * }
	 */
	props: {
		listItems: {
			type: Array,
			default: () => []
		},
		disabled: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss" scoped>
.list {
	display: flex;
	flex-direction: column;
	gap: $gutter-md;
	max-height: 325px;
}
</style>
